import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  gap: 1rem;
  align-items: flex-end;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
`;

export const Col = styled.div`
  flex: 1 1 200px;
`;

export const RemoveCol = styled.div`
  flex: 0 0 auto;
`;

export const Label = styled.label`
  display: block;
  font-weight: bold;
  margin-bottom: 0.25rem;
  font-size: 0.875rem;
`;

export const Input = styled.input`

`;